import { DataBean } from "../DataBean";

export class PhysicalTakingItemCatalog extends DataBean {


    public async getPhysicalTakingItemCatalog(idPhysicalTaking:any,idFixedAsset:any,idItem:any,accountID:any,regex:any,ticketCode:any,state:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPhysicalTakingItemCatalog_Number_Number_Number_Number_String_Number_Number_Number_Number", [idPhysicalTaking,idFixedAsset,idItem,accountID,regex,ticketCode,state,page,recordsPerPage]);
    }

 
}